<template>
    <b-card class="m-1" body-class="d-flex flex-column justify-content-center align-items-center">
        <b-img fluid width="300" :src="img" class="m-3"/>
        <h3 class="text-muted my-2 text-center">{{ title }}</h3>
        <b-spinner v-if="loading" variant="primary"></b-spinner>
        <b-button v-else variant="primary" class="mt-1" @click="goToLogin">Giriş ekranına dön</b-button>
    </b-card>
</template>

<script>
import { BCard,BSpinner,BImg,BButton } from 'bootstrap-vue'
import { UserApi } from '@/api/user'
export default {
    components:{
        BCard,
        BSpinner,
        BImg,
        BButton
    },
    mounted(){
        this.confirm()
    },  
    data() {
        return {
            code:this.$route.params?.code || null,
            loading:true,
            title:'Kullanıcı onaylanıyor...',
            img:require('@/assets/images/illustrations/undraw-security-on.svg')
        }
    },
    methods:{
        goToLogin(){
            this.$router.push({ name: 'login' })
        },
        confirm(){
            if(!this.code){
                this.loading = false
                this.title = 'Aktivasyon bağlantısı geçersiz. Lütfen size iletilen bağlantıyı kontrol ediniz.'
                return
            }
            UserApi.Confirm(this.code).then(res=>{
                this.$result(res)
                this.loading = false
                if(res?.data?.Success){
                    this.title = res.data.Message || 'Hesabınız aktif edildi. Giriş ekranına yönlendiriliyorsunuz...'
                    setTimeout(this.goToLogin, 3000)
                }else{
                    this.title = res?.data?.Message || 'Aktivasyon işlemi tamamlanamadı. Lütfen sistem yöneticinize başvurunuz.'
                }
            }).catch(err=>{
                this.$result(null,err)
                this.loading = false
                this.title = 'Aktivasyon işlemi tamamlanamadı. Lütfen sistem yöneticinize başvurunuz.'
            })
        }
    }
}
</script>

<style>

</style>
